import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../css/city.css";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import CustomButton from "./CustomButton";
import Loader from "../dist/Loader";
const CityPage = () => {
  const navigate = useNavigate();
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [cityData, setCityData] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [editedCityData, setEditedCityData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    axios.get(`${BASE_URL}/api/states`, {
      headers: getAuthHeaders()
    })
      .then((res) => setStates(res.data))
      .catch((err) => {
        console.error("Error fetching states:", err);
        if (err.response?.status === 401) {
          alert("Session expired. Please login again.");
          navigate("/login");
        }
      });
  }, [navigate]);

 const fetchCityData = () => {
  if (!selectedState) {
    alert("Please select a state.");
    return;
  }

  const selectedStateObj = states.find(state => state.name === selectedState);
  if (!selectedStateObj) {
    alert("Invalid state selection.");
    return;
  }

  const stateId = selectedStateObj.id;
  setIsLoading(true);

  axios
    .get(`${BASE_URL}/api/cities-with-state/${stateId}`, {
      headers: getAuthHeaders()
    })
    .then((res) => {
      setCityData(res.data);
    })
    .catch((err) => {
      console.error("Error fetching cities:", err);
      if (err.response?.status === 401) {
        alert("Session expired. Please login again.");
        navigate("/login");
      }
    })
    .finally(() => {
      setIsLoading(false);
    });
};

  const handleEdit = (city) => {
    setEditingRow(city.id);
    setEditedCityData({ ...city });
  };

  const handleInputChange = (e, field) => {
    setEditedCityData({ 
      ...editedCityData, 
      [field]: e.target.value 
    });
  };

  const handleSave = async () => {
    try {
      // Find the matching state ID from state_name
      const selectedStateObj = states.find(
        state => state.name === editedCityData.state_name || state.name === selectedState
      );

      const updatedPayload = {
        ...editedCityData,
        state_id: selectedStateObj?.id
      };

      await axios.put(
        `${BASE_URL}/api/cities/${editedCityData.id}`,
        updatedPayload,
        {
          headers: getAuthHeaders()
        }
      );

      setCityData(cityData.map(city =>
        city.id === editedCityData.id ? { ...editedCityData } : city
      ));
      setEditingRow(null);
    } catch (error) {
      console.error("Error updating city:", error);
      if (error.response?.status === 401) {
        alert("Session expired. Please login again.");
        navigate("/login");
      }
    }
  };

  const handleCancel = () => {
    setEditingRow(null);
    setEditedCityData({});
  };

  return (
 <div className="p-2  border-2 border-gray-300 rounded-lg bg-white">
 <div className={`main-container ${isLoading ? "blur-sm pointer-events-none" : ""}`}>
      <div className="p-4 border-2 border-gray-300 rounded-lg bg-gray-50">

        
        <div className="city-page-btn-container">
          <button 
            className="addcity-btn-primary" 
            onClick={() => navigate("/add-city-hq")}
          >
            Add City / HQ
          </button>
        </div>

        <div className="city-filter-section">
          <label className="city-filter-label">Select State:</label>
          <select 
            className="city-filter-dropdown" 
            value={selectedState} 
            onChange={(e) => setSelectedState(e.target.value)}
          >
            <option value="">-- Select --</option>
            {states.map((state) => (
              <option key={state.id} value={state.name}>
                {state.name}
              </option>
            ))}
          </select>
          <CustomButton className="city-btn-go" onClick={fetchCityData}>
            Go
          </CustomButton>
        </div>
      </div>

      {cityData.length > 0 && (
       <div className="p-2  border-2 border-gray-300 rounded-lg bg-white mt-5">
            
<h1 class="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4"><span class="text-blue-700">City </span><span class="text-blue-500">List</span></h1>
         <div className="border rounded shadow  table-wrapper">
        <table className="unlock-dcr-leave-table text-sm ">
          <thead className="bg-blue-500 text-white">

              <tr>
                <th>S.No</th>
                <th>City</th>
                <th>State</th>
                <th>No. of Doctors</th>
                <th>No. of Chemists</th>
                <th>No. of Stockists</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {cityData.map((city, index) => (
                <tr key={city.id}>
                  <td>{index + 1}</td>
                  <td>
                    {editingRow === city.id ? (
                      <input
                        type="text"
                        value={editedCityData.name}
                        onChange={(e) => handleInputChange(e, "name")}
                        className="city-edit-input"
                      />
                    ) : (
                      city.name
                    )}
                  </td>
                  <td>{city.state_name || "Unknown State"}</td>
                  <td>{city.doctor_count || 0}</td>
                  <td>{city.chemist_count || 0}</td>
                  <td>{city.stockist_count || 0}</td>
                  {/* <td>
                    {editingRow === city.id ? (
                      <>
                        <button className="btn-save" onClick={handleSave}>
                          Save
                        </button>
                        <button className="btn-cancel" onClick={handleCancel}>
                          Cancel
                        </button>
                      </>
                    ) : (
                      <button 
                        className="btn-edit" 
                        onClick={() => handleEdit(city)}
                      >
                        Edit
                      </button>
                    )}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default CityPage;
